import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Table, useSort, SortDirection } from '@amzn/stencil-react-components/table';
import { getEpochTime } from '../../util/commonUtils';

const SortableTable = props => {
  const { activeSortId, sortDirection, onSort } = useSort({
    defaultSortDirection: SortDirection.Ascending,
    defaultActiveSortId: props.defaultActiveSortId,
  });
  const data = props.data;
  const [sortedData, setSortedData] = useState(data);
  const isDateField = activeSortId.toLowerCase().endsWith('date');

  const compare = (a, b) => {
    const dataA = a[activeSortId];
    const dataB = b[activeSortId];

    return sortDirection === SortDirection.Ascending
      ? dataA > dataB
        ? -1
        : 1
      : dataA < dataB
        ? -1
        : 1;
  };

  const dateCompare = (a, b) => {
    const dataA = getEpochTime(a[activeSortId]);
    const dataB = getEpochTime(b[activeSortId]);

    return sortDirection === SortDirection.Ascending
      ? dataA > dataB
        ? -1
        : 1
      : dataA < dataB
        ? -1
        : 1;
  };

  useEffect(
    () => {
      const segments = !isDateField ? data?.sort(compare) : data?.sort(dateCompare);
      setSortedData(segments);
    },
    [activeSortId, sortDirection, onSort],
  );

  return (
    <Table
      data-testid="sortable-table"
      actionColumnIndex={0}
      columns={props.columns}
      data={sortedData}
      activeSortId={activeSortId}
      sortDirection={sortDirection}
      onSort={onSort}
      getRowAttributes={props.getRowAttributes}
      renderCardForRow={props.renderCardForRow}
    />
  );
};

SortableTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  defaultActiveSortId: PropTypes.string.isRequired,
};

export default SortableTable;
